import {
    useGetCartInfoQuery,
    useGetPresentsProductsQuery,
    useUpdatePresentsProductsMutation,
} from '@/shared/api-rtk/api-list/cartApi'
import cl from 'classnames'
import styles from './ProductToPresent.module.scss'
import classNames from 'classnames'
import Link from 'next/link'
import React, { useEffect } from 'react'

export const ProductToPresent = ({ refetchCart }) => {
    const {
        data,
        isLoading,
        isSuccess,
        refetch: refetchPresents,
        error,
    } = useGetPresentsProductsQuery()

    const [updateproducts, {}] = useUpdatePresentsProductsMutation()

    const checkHandler = async (productId, checked, action) => {
        if (action === 'increment') {
            if (
                data.product_to_present.totalCount <=
                data.product_to_present.currentCount
            )
                return
        }
        await updateproducts({
            product_id: productId,
            checked: !checked,
            action: action,
        })
        await refetchPresents()
        await refetchCart()
    }

    useEffect(() => {
        refetchPresents()
    }, [])

    if (isLoading) {
        return <div>Загрузка...</div>
    }

    if (isSuccess && !data.product_to_present.status) {
        return
    }

    return (
        <div>
            <h3>Выберите товары в подарок</h3>
            <div
                className={'OrdersCart'}
                style={{ width: '100%', height: '400px', overflow: 'auto' }}
            >
                <div className={cl(styles.item)}>
                    <div
                        style={{ marginBottom: '0px' }}
                        className={'item-cart title'}
                    >
                        <div className={'about-item'}>
                            <span className={styles.conter}></span>{' '}
                            <div className={styles.conter}></div>
                            <span></span>
                            <div className={'text-item'}></div>
                        </div>
                        <div className={'info-item'}>
                            <div className={'info price'}>
                                <h6>Розничная цена</h6>
                            </div>

                            <div className={'info sum'}>
                                <h6>Цена по акции</h6>
                            </div>

                            <div className={'cart-present'}></div>
                        </div>
                    </div>
                </div>
                <div>
                    {data.product_to_present.products.map((item) => {
                        const itemUrl = item.href.split('/').reverse()[0]
                        return (
                            item.stok_quantity > 0 && (
                                <div key={item.id} className={cl(styles.item)}>
                                    <div
                                        key={item.id}
                                        style={{ marginBottom: '20px' }}
                                        className={'item-cart'}
                                    >
                                        <div className={'about-item'}>
                                            <span
                                                onClick={() =>
                                                    checkHandler(
                                                        item.id,
                                                        false,
                                                        'dicrement'
                                                    )
                                                }
                                                className={styles.conter}
                                            >
                                                -
                                            </span>{' '}
                                            <div className={styles.conter}>
                                                {item.quantity ?? 0}
                                            </div>{' '}
                                            <span
                                                onClick={() =>
                                                    checkHandler(
                                                        item.id,
                                                        false,
                                                        'increment'
                                                    )
                                                }
                                                className={classNames(
                                                    styles.conter,
                                                    data.product_to_present
                                                        .totalCount <=
                                                        data.product_to_present
                                                            .currentCount
                                                        ? styles.disable
                                                        : ''
                                                )}
                                            >
                                                +
                                            </span>
                                            <img
                                                className="cart-thumb"
                                                src={item.thumb}
                                                alt=""
                                            />
                                            <div className={'text-item'}>
                                                <Link href={'/' + itemUrl}>
                                                    {item.name}
                                                </Link>
                                            </div>
                                        </div>
                                        <div className={'info-item'}>
                                            <div className={'info price'}>
                                                <h2>
                                                    {parseInt(
                                                        item.price
                                                    ).toLocaleString()}{' '}
                                                    ₽
                                                </h2>
                                            </div>

                                            <div className={'info sum'}>
                                                <h2>1 ₽</h2>
                                            </div>

                                            <div className={'cart-present'}>
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    version="1.1"
                                                    viewBox="0 0 512 512"
                                                    xmlSpace="preserve"
                                                >
                                                    <path
                                                        fill="#FFEE43"
                                                        d="M480 252c-4.422 0-8 3.582-8 8H40c0-4.418-3.578-8-8-8s-8 3.582-8 8v208c0 22.055 17.945 40 40 40h384c22.055 0 40-17.945 40-40V260c0-4.418-3.578-8-8-8z"
                                                    ></path>
                                                    <path
                                                        fill="#FFD100"
                                                        d="M480 164H32c-17.648 0-32 14.355-32 32v48c0 17.645 14.352 32 32 32h448c17.648 0 32-14.355 32-32v-48c0-17.645-14.352-32-32-32z"
                                                    ></path>
                                                    <path
                                                        fill="#FF4F19"
                                                        d="M224 156H288V508H224z"
                                                    ></path>
                                                    <path
                                                        fill="#E7001E"
                                                        d="M224 407.313L288 471.313 288 448.688 224 384.688z"
                                                    ></path>
                                                    <path
                                                        fill="#E7001E"
                                                        d="M224 367.313L288 431.313 288 408.688 224 344.688z"
                                                    ></path>
                                                    <path
                                                        fill="#E7001E"
                                                        d="M288 231.313L288 208.688 235.313 156 224 156 224 167.313z"
                                                    ></path>
                                                    <path
                                                        fill="#E7001E"
                                                        d="M224 327.313L288 391.313 288 368.688 224 304.688z"
                                                    ></path>
                                                    <path
                                                        fill="#E7001E"
                                                        d="M224 424.688L224 447.313 284.688 508 288 508 288 488.688z"
                                                    ></path>
                                                    <path
                                                        fill="#E7001E"
                                                        d="M224 287.313L288 351.313 288 328.688 224 264.688z"
                                                    ></path>
                                                    <path
                                                        fill="#E7001E"
                                                        d="M224 207.313L288 271.313 288 248.688 224 184.688z"
                                                    ></path>
                                                    <path
                                                        fill="#E7001E"
                                                        d="M267.313 508L224 464.688 224 487.313 244.688 508z"
                                                    ></path>
                                                    <path
                                                        fill="#E7001E"
                                                        d="M224 247.313L288 311.313 288 288.688 224 224.688z"
                                                    ></path>
                                                    <g>
                                                        <path
                                                            fill="#E7001E"
                                                            d="M424 291.969c-31.586 0-50.203-32.934-68.203-64.785-13.333-23.584-27.024-47.742-46.855-58.039 37.64-14.671 85.006-34.957 99.145-49.094 26.516-26.512 26.516-69.652 0-96.164-26.516-26.516-69.656-26.516-96.172 0C295.42 40.378 270.544 102.129 256 140.862c-14.544-38.732-39.42-100.484-55.914-116.975-26.516-26.516-69.656-26.516-96.172 0-26.516 26.512-26.516 69.652 0 96.164 14.139 14.137 61.504 34.423 99.145 49.094-19.832 10.297-33.522 34.455-46.855 58.039-18 31.852-36.617 64.785-68.203 64.785-6.625 0-12 5.371-12 12s5.375 12 12 12c45.586 0 68.703-40.895 89.094-76.977 14.836-26.238 28.844-51.023 46.906-51.023V188h64v-.031c18.063 0 32.07 24.785 46.906 51.023 20.391 36.082 43.508 76.977 89.094 76.977 6.625 0 12-5.371 12-12s-5.376-12-12.001-12zM328.883 40.855c8.578-8.578 19.844-12.863 31.117-12.863 11.266 0 22.539 4.289 31.117 12.863 17.156 17.156 17.156 45.07 0 62.227-12.219 12.219-69.773 36.078-115.156 52.926 16.844-45.383 40.703-102.934 52.922-115.153zm-208 0c8.578-8.578 19.844-12.863 31.117-12.863 11.266 0 22.539 4.289 31.117 12.863 12.219 12.219 36.078 69.77 52.922 115.152-45.383-16.848-102.938-40.707-115.156-52.926-17.156-17.155-17.156-45.069 0-62.226z"
                                                        ></path>
                                                    </g>
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        )
                    })}
                </div>
                <div></div>
            </div>
            выбранно {data.product_to_present.currentCount} из{' '}
            {data.product_to_present.totalCount}
        </div>
    )
}
